import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import ValidationCycleStore from './validationCycles/'
import RPStore from './rps'
import FollowUp from './followUp'
import Review from './review'
import Cases from './cases'
import CaseTrends from './caseTrends'
import Trends from './trends'
import Errors from './errors'
import IGS from './igs'
import Clusters from './clusters'

export default ({
  namespaced: true,
  modules: {
    validationCycles: ValidationCycleStore,
    rps: RPStore,
    followUp: FollowUp,
    review: Review,
    cases: Cases,
    caseTrends: CaseTrends,
    trends: Trends,
    errors: Errors,
    igs: IGS,
    clusters: Clusters
  },
  state: {
    editorConfig: {
      toolbar: ['heading', '|', 'bold', 'italic', 'bulletedList', 'numberedList'],
    }
  }
})